/**
 * Single source of truth for the `md` breakpoint the app branches on in JS —
 * the value handed to `useIsMobile()` next to every `max-md:` / `md:` class.
 * Kept in one place so the CSS layout and the JS-gated parts of the tree can't
 * start flipping at different widths.
 *
 * Mirrors Tailwind's default `md` (48rem/768px). Note the boundary itself
 * differs by a pixel: Tailwind's `md:` is `min-width: 768px`, while
 * `useIsMobile` compares `width <= breakpoint`, so at exactly 768px the CSS is
 * already in desktop mode and the hook still reports mobile.
 */
export const MOBILE_BREAKPOINT = 768;
